// if (isDebug) {
//     apiKey = "debug_api_key"
//     product_sub1 = "price_1PTXiYFO0Z7AxRyVxKfgQJGN"
//     product_sub2 = "price_1PTXymFO0Z7AxRyVUaUbVqLx"
//     product_sub3 = "price_1PTXz6FO0Z7AxRyVoLZr5hlb"
//     publishedKey = "pk_test_51IGY1NFO0Z7AxRyVCcNCMbMztQ5qOVRtJtzLw9uaj5jr48rWMyJKcfw163UauMHPBq9Nl9DIewMTF3wGUzQMsltB00Q1msCwam"
//     accountKey = "acct_1IGY1NFO0Z7AxRyV"
//
//     createCustomer = "https://mystripeserver.vercel.app/api/create-customer"
//     createSubscription ="https://mystripeserver.vercel.app/api/create-subscription"
//     checkSubscription = "https://mystripeserver.vercel.app/api/check-subscription?customerId="
//     cancelSubscription = "https://mystripeserver.vercel.app/api/cancel-subscription"
//     getCustomerID = "https://mystripeserver.vercel.app/api/get-customer-id"
// } else {
//
//     apiKey = "release_api_key"
//     product_sub1 = "price_1PW7EgFO0Z7AxRyVoqQFOKxm"
//     product_sub2 = "price_1PW7I2FO0Z7AxRyVpDJF7AmS"
//     product_sub3 = "price_1PW7JLFO0Z7AxRyVBL5kGR3A"
//     publishedKey = "pk_live_51IGY1NFO0Z7AxRyVICahNcT154GDipL9Bg441fwjvn6bsbbWfeOjp6OJ6A2vdzPXVwGvLJMPORydyOgYfGn3orpH00IylzXQpT"
//     accountKey = "acct_1IGY1NFO0Z7AxRyV"
//
//     checkSubscription = "https://mystripe-production.vercel.app"
//     createCustomer = "https://mystripe-production.vercel.app/api/create-customer"
//     createSubscription ="https://mystripe-production.vercel.app/api/create-subscription"
//     cancelSubscription = "https://mystripe-production.vercel.app/api/cancel-subscription"
//     getCustomerID = "https://mystripe-production.vercel.app/api/get-customer-id"
//
// }





import axios from "./axios";

export const endpoints = {
    checkSubscription: (customerId) => `/api/check-subscription?customerId=${customerId}`,
    createCustomer: '/api/create-customer',
    createSubscription: '/api/create-subscription-3ds',
    cancelSubscription: '/api/cancel-subscription',
    getCustomerId: '/api/get-customer-id',
};

const Api = {
    async checkSubscription(customerId){
        try {
            const res = await axios.post(endpoints.checkSubscription(customerId));
            return res.data
        } catch (error) {
            return false;
        }
    },
    async createCustomer(email, name){

        let formBody = [];
        formBody.push(encodeURIComponent('email') + "=" + encodeURIComponent(email));
        formBody.push(encodeURIComponent('name') + "=" + encodeURIComponent(name));
        formBody = formBody.join("&");

        const res = await axios({
            method: "post",
            url: endpoints.createCustomer,
            data: formBody,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        })

        return res.data
    },
    async createSubscription(paymentMethodId, priceId, customerId){

        let formBody = [];
        formBody.push(encodeURIComponent('paymentMethodId') + "=" + encodeURIComponent(paymentMethodId));
        formBody.push(encodeURIComponent('priceId') + "=" + encodeURIComponent(priceId));
        formBody.push(encodeURIComponent('customerId') + "=" + encodeURIComponent(customerId));
        formBody = formBody.join("&");

        const res = await axios({
            method: "post",
            url: endpoints.createSubscription,
            data: formBody,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        })

        return res.data
    },
    async cancelSubscription(subscriptionId){

        let formBody = [];
        formBody.push(encodeURIComponent('subscriptionId') + "=" + encodeURIComponent(subscriptionId));
        formBody = formBody.join("&");

        const res = await axios({
            method: "post",
            url: endpoints.cancelSubscription,
            data: formBody,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        })

        return res.data
    },
    async getCustomerId(email){
        const res = await axios.post(endpoints.getCustomerId, {
            email
        });
        return res.data
    },
};

export default Api;
